import { Skeleton, Stack } from '@mui/material';

export const ProjectLayoutSkeleton = () => {
  return (
    <Stack gap={3}>
      {/* Header section */}
      <Stack
        direction="row"
        justifyContent="space-between"
        flexWrap="wrap"
        gap={2}
      >
        <Stack gap={2}>
          {/* Project name + number */}
          <Stack direction="row" gap={1} alignItems="center">
            <Skeleton variant="rounded" width={180} height={32} />
            <Skeleton variant="rounded" width={60} height={20} />
          </Stack>

          {/* Customer + Manager labels */}
          <Stack direction="row" gap={3}>
            <Skeleton variant="rounded" width={140} height={24} />
            <Skeleton variant="rounded" width={140} height={24} />
          </Stack>
        </Stack>

        {/* Navigation tabs skeleton */}
        <Stack direction="row" gap={2}>
          <Skeleton variant="pilled" width={200} height={36} />
          <Skeleton variant="circular" width={36} height={36} />
        </Stack>
      </Stack>

      {/* Content area skeleton */}
      <Stack gap={2}>
        <Skeleton variant="rounded" width="100%" height={200} />
        <Skeleton variant="rounded" width="100%" height={150} />
      </Stack>
    </Stack>
  );
};
